import { FC } from "react";

import SelectProductsContainer from "@app/containers/selectProducts";

const SelectProductsPage: FC = () => <SelectProductsContainer />;

export default SelectProductsPage;
